import { FC } from 'react';

import { HotColumn } from '@handsontable/react';
import { IList } from 'core/API/listApi';

import Grid from '../Grid';
import { MAssortmentStoreHeader, translateHeaders } from './helpers/HeadersList';
import { requireTitle } from './helpers/utils';
import { eanValidator, stringIdValidator } from '../Validators';

export const MAssortmentStore: FC<{
    list: IList;
    toolId: number;
}> = ({ list, toolId }) => {
    const translatedHeaders = translateHeaders(MAssortmentStoreHeader);

    return (
        <Grid toolId={toolId} headers={MAssortmentStoreHeader} list={list}>
            <HotColumn title={requireTitle(translatedHeaders[0])} validator={eanValidator(false)} />
            <HotColumn type="text" validator={stringIdValidator(false)} title={requireTitle(translatedHeaders[1])} />
        </Grid>
    );
};
